Alpine.data("scanner", () => ({
    stream: null,
    animFrameId: null,
    torchSupported: false,
    torchOn: false,
    scanSuccess: false,
    errorBanner: null,
    frameSize: 300,

    init() {
        document.addEventListener("visibilitychange", () => {
            if (!this.$wire.cameraOpen) return;
            if (document.hidden) {
                this.$refs.video.pause();
            } else {
                this.$refs.video.play();
            }
        });
    },

    async startCamera() {
        await this.$wire.openCamera();

        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment" },
            });
        } catch (e) {
            const message =
                e.name === "NotAllowedError"
                    ? "Camera permission denied. Please enable camera access in browser settings to continue."
                    : "Unable to access camera. Please check that it is not in use by another application.";
            await this.$wire.set("cameraError", message);
            await this.$wire.closeCamera();
            return;
        }

        const video = this.$refs.video;
        video.srcObject = this.stream;
        video.play();

        const track = this.stream.getVideoTracks()[0];
        await this.detectTorch(track);

        this.decodeLoop();
    },

    teardownStream() {
        if (this.animFrameId) {
            cancelAnimationFrame(this.animFrameId);
            this.animFrameId = null;
        }

        if (this.stream) {
            this.stream.getTracks().forEach((t) => t.stop());
            this.stream = null;
        }

        this.torchSupported = false;
        this.torchOn = false;
    },

    stopCamera() {
        this.teardownStream();
        this.scanSuccess = false;
        this.errorBanner = null;
        this.$wire.closeCamera();
    },

    async detectTorch(track) {
        try {
            const caps = track.getCapabilities();
            this.torchSupported = !!caps.torch;
        } catch (e) {
            this.torchSupported = false;
        }
    },

    async toggleTorch() {
        if (!this.stream) return;
        const track = this.stream.getVideoTracks()[0];
        try {
            await track.applyConstraints({
                advanced: [{ torch: !this.torchOn }],
            });
            this.torchOn = !this.torchOn;
        } catch (e) {
            this.errorBanner = "Torch is not supported on this device.";
        }
    },

    decodeLoop() {
        const video = this.$refs.video;
        const canvas = this.$refs.canvas;

        if (video.readyState !== video.HAVE_ENOUGH_DATA) {
            this.animFrameId = requestAnimationFrame(() => this.decodeLoop());
            return;
        }

        const scale = Math.max(
            video.videoWidth / video.clientWidth,
            video.videoHeight / video.clientHeight,
        );

        const cropSize = Math.round(this.frameSize * scale);
        const cropX = Math.round((video.videoWidth - cropSize) / 2);
        const cropY = Math.round((video.videoHeight - cropSize) / 2);

        canvas.width = cropSize;
        canvas.height = cropSize;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(
            video,
            cropX,
            cropY,
            cropSize,
            cropSize,
            0,
            0,
            cropSize,
            cropSize,
        );

        const imageData = ctx.getImageData(0, 0, cropSize, cropSize);
        const decoded = jsQR(
            imageData.data,
            imageData.width,
            imageData.height,
            {
                inversionAttempts: "dontInvert",
            },
        );

        if (decoded) {
            const itemId = decodeURIComponent(decoded.data);
            this.onQrSuccess(itemId);
        } else if (!this.scanSuccess) {
            this.animFrameId = requestAnimationFrame(() => this.decodeLoop());
        }
    },

    onQrSuccess(itemId) {
        this.stopCamera();
        this.scanSuccess = true;

        const audioCtx = new (
            window.AudioContext || window.webkitAudioContext
        )();
        const osc = audioCtx.createOscillator();
        const gain = audioCtx.createGain();
        osc.connect(gain);
        gain.connect(audioCtx.destination);
        osc.frequency.value = 880;
        gain.gain.setValueAtTime(0.3, audioCtx.currentTime);
        gain.gain.exponentialRampToValueAtTime(
            0.001,
            audioCtx.currentTime + 0.2,
        );
        osc.start(audioCtx.currentTime);
        osc.stop(audioCtx.currentTime + 0.2);

        this.teardownStream();

        this.$dispatch("qr-scanned", { itemId });

        setTimeout(() => {
            this.scanSuccess = false;
        }, 300);
    },
}));
